var LoadingSpinnerComponent = (function () {
    function LoadingSpinnerComponent() {
        this.isLoading = false;
    }
    LoadingSpinnerComponent.prototype.ngOnInit = function () {
    };
    return LoadingSpinnerComponent;
}());
export { LoadingSpinnerComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/core/loading-spinner/loading-spinner.component.ts.pre-build-optimizer.js